import { OnboardingWrapper } from '@/src/common/wrappers/OnboardingWrapper'
import type { ComponentProps } from 'react'
import { useMediaQuery } from 'react-responsive'
import { View } from 'react-native'

export function CardApplicationWrapper({
  children,
  ...props
}: ComponentProps<typeof OnboardingWrapper>) {
  const isFixedWidthViewport = useMediaQuery({ minWidth: 720 })

  return (
    <OnboardingWrapper paddingHorizontal={16} {...props}>
      <View style={{ flex: 1, width: isFixedWidthViewport ? 500 : '100%' }}>{children}</View>
    </OnboardingWrapper>
  )
}
